
import { defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  inheritAttrs: false,
  emits: ['clear'],
  setup() {
    const mainStore = useMainStore();

    function onEnter(input) {
      input.target.blur();
    }

    return {
      onEnter,
      mainStore,
    };
  },
});
